/**
* Created by lobin on 2020/7/14.
*/
<template>
  <a-card :body-style="{padding: '24px 32px'}" :bordered="false">
    <a-form-model layout="inline" @submit="handleSearch" @submit.native.prevent style="text-align: right;overflow: hidden">
      <a-form-model-item style="float: left">
        <a-button icon="plus" @click="showEditDialog">添加</a-button>
      </a-form-model-item>
      <a-form-model-item>
				<company-search
					v-model="search.company"
					placeholder="请选择所属公司"
				/>
			</a-form-model-item>
			<a-form-model-item>
				<a-input v-model="search.username" placeholder="输入用户名" allowClear></a-input>
			</a-form-model-item>
			<a-form-model-item>
				<a-input v-model="search.mobile" placeholder="输入电话" allowClear></a-input>
			</a-form-model-item>
			<a-form-model-item style="margin-right: 0">
				<a-button
					type="primary"
					html-type="submit"
					icon="search"
				>
					查询
				</a-button>
			</a-form-model-item>
		</a-form-model>
		<a-divider />
		<a-table
			:loading="listloading"
			:columns="columns"
			:data-source="list"
			:scroll="{y: 500 }"
			:pagination="pager"
			@change="change">
			<span slot="company" slot-scope="text">
          <span style="margin-left: 10px" v-for="item in text" :key="item.id">{{ item.name }}</span>
			</span>
			<span slot="subscribe" slot-scope="text">
				<a-tag color="#87d068" v-if="text === 1">已关注</a-tag>
				<a-tag color="#f50" v-else>未关注</a-tag>
			</span>
			<span slot="action" slot-scope="text, record">
				<a @click="modify(record._id)">修改</a>
				<a-divider type="vertical" />
				<a href="javascript:;" @click="passwordReset(record)">重置密码</a>
			</span>
		</a-table>
	  <addAndModify ref="addAndModify" @close="getList" />
	</a-card>
</template>

<script type="text/babel">
import { getAdminUser, resetPassword } from '@/api/user';
import { getRole } from '@/api/settings';
import addAndModify from './addAndModify.vue';

export default {
  components: { addAndModify },
  data() {
    return {
      listloading: false,
      list: [],
      pager: {},
      search: {},
      searchRange: [],
		  roles: [],
    };
  },
  created() {
    this.getList();
  },
  computed: {
    columns() {
      return [
	      {
		      title: '#',
		      dataIndex: 'index',
		      customRender: (text, row, index) => index + 1,
		      key: 'index',
		      width: '50px',
	      },
        {
          title: '公司',
          dataIndex: 'company',
          key: 'companyName',
	        scopedSlots: { customRender: 'company' },
        },
        {
          title: '用户名',
          dataIndex: 'username',
          key: 'username',
          scopedSlots: { customRender: 'user' },
        },
        {
          title: '电话',
          dataIndex: 'mobile',
          key: 'mobile',
        },
        {
          title: '时间',
          dataIndex: 'ctime',
          key: 'ctime',
        },
	      {
		      title: '操作',
		      key: 'action',
		      fixed: 'right',
		      width: 142,
		      scopedSlots: { customRender: 'action' },
	      },
      ];
    },
  },
  methods: {
  	async getRoleList() {
  		const { data } = getRole();
  		this.roles = data;
	  },
    async getList() {
      this.listloading = true;
      const q = { ...this.search };
      try {
        const { data: { docs, pager } } = await getAdminUser(q);
        this.list = docs;
        this.pager = {
	        ...pager,
	        showTotal: (total) => `共计 ${total} 条信息`,
        };
      } catch (e) {
        console.error(e);
      }
      this.listloading = false;
    },
    change(pagination) {
      this.search.page = pagination.current;
      this.getList();
    },
    handleSearch() {
      this.getList();
    },
    showEditDialog() {
    	this.$refs.addAndModify.show('add');
    },
	  modify(id) {
	    this.$refs.addAndModify.show('modify', id);
	  },
	  passwordReset({ _id }) {
    	const that = this;
    	this.$confirm({
			    title: '提示',
			    content: '重置密码会重置为电话后四位',
			    onOk() {
		        resetPassword(_id).then(() => {
		          that.$message.success('重置成功');
		        });
			    },
	    });
	  },
  },
};
</script>

<style lang="less" rel="stylesheet/less">
	.user-list {

	}
</style>
